// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7ee26812","455":"0db0b5b7","977":"24a1c7c5"}[chunkId] + ".chunk.js";
};